import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUpdate = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		fill: "#444",
		transform: "scale(0.03125 0.03125)",
		children: /* @__PURE__ */ _jsx("path", { d: "M948.992 75.008c-49.856-50.016-115.36-75.008-180.992-75.008-65.504 0-131.008 24.992-180.992 75.008l-586.016 585.984-0.992 363.008h361.984l587.008-587.008c100-100 100-261.984 0-361.984zM308.992 896h-52.992v-128h-127.264l0.128-53.76 548.64-548.736 180.992 180.992-549.504 549.504z" })
	})
});
export default SvgUpdate;
